/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Badge, Grid, Typography} from "@mui/material";
import {
    AccountBalance,
    AccountCircleOutlined,
    BadgeOutlined,
    CakeOutlined, FlagOutlined,
    PointOfSaleOutlined
} from "@mui/icons-material";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoTextoBoton from "../../../Modulo_formularios/Componentes/IngresoTextoBoton";

const Formulario_Reserva_CheckIn_Acompanante = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={12}
                spacing={2}
            >

                <Grid container size={{xs: 4, sm: 4, md: 4}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Tipo Id'} dato={'tipoCc'} {...props}
                                   opciones={['C.C', 'T.I', 'R.C', 'T.E']}
                    />
                </Grid>

                <Grid container size={{xs: 8, sm: 8, md: 8}}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Num Identificacion'} dato={'cc'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Datos del huesped</Typography>
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombres'} dato={'nombres'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Apellidos'} dato={'apellidos'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Reserva_CheckIn_Acompanante